import { Button, Grid, TextField, Container, CircularProgress } from "@mui/material"
import { GeneralStyles } from "../../styles/GeneralStyles"
import { AddOrEditFormStyles } from "../../styles/AddOrEditFormStyles"
import { useState, useEffect } from "react"
import { saveProductModelList, editProductModelList, saveGenericModelList, editGenericModelList
    , saveCotscoProdInventory, editCotscoProdInventory, saveGenericProdInventory, editGenericProdInventory
} from "../../services/CatalogsService"
import React from "react"
import {notifyInvalidEntity, notifyProductSaved, notifyDuplicatesModelList} from "../notifications"
import { useLocation } from 'react-router-dom';

const AddOrEditProductForm = ({handleCloseModal, action, productOject, fetchData}) => {
    const [customer, setCustomer] = useState(productOject ? productOject.customer : "")
    const [material, setMaterial] = useState(productOject ? productOject.material : "")
    const [quantity, setQuantity] = useState(productOject ? productOject.quantity : 1)
    const [plant, setPlant] = useState(productOject ? productOject.plant: "")
    const [storageLocation, setStorageLocation] = useState(productOject ? productOject.storageLocation : 4000);
    const [crossReference, setCrossReference] = useState(productOject ? productOject.crossReference : "");
    const token = localStorage.getItem("site")
    const [savingIsLoading, setSavingIsLoading] = useState(false)
    const location = useLocation();
    const { pathname } = location;
    const [showExtraFields, setShowExtraFields] = useState(true);
    const [availabilityDate, setAvailabilityDate] = useState(productOject ? productOject.availabilityDate : "")
    const clearForm = () => {
        setCustomer("")
        setMaterial("")
        setQuantity(0)
        setPlant("")
        setStorageLocation(0)
        setCrossReference("")
    }

    const showDataEntityErrors = (errors) => {
        for (let i = 0; i < errors.length; i++) {
            notifyInvalidEntity(errors[i])        
        }
    }

    const validarExpresionRegular = () => {
        const dateRegex = /^\d{4}\.\d{2}\.\d{2}$/;
        if (!dateRegex.test(availabilityDate)) {
            notifyInvalidEntity("The availability date must be in the format YYYY.MM.DD");
            return false;
        }

        // Validar si la fecha tiene sentido (meses 1-12, días válidos)
        const [year, month, day] = availabilityDate.split('.').map(Number);
        const isValidDate = !isNaN(new Date(`${year}-${month}-${day}`).getTime());
        if (month < 1 || month > 12 || day < 1 || day > 31 || !isValidDate) {
            notifyInvalidEntity("The availability date is not valid");
            return false;
        }

        return true;
    };

    const saveProductModelListAction = async ()=>{
        if(customer === "" || plant === "" || material === "") {
            notifyInvalidEntity("Customer, Plant and Material are required")
            return
        }
        if (pathname === "/dashboard/products/CotscoProd" || pathname === "/dashboard/products/GenericProd"){
            const isValid = validarExpresionRegular();
            if (!isValid) {
                setSavingIsLoading(false);
                return;
            }
        }
        setSavingIsLoading(true)
        let body ={}
        if (showExtraFields){
            body = {
                customer: customer,
                material: material,
                quantity: quantity,
                plant: plant,
                storageLocation: storageLocation,
                crossReference: crossReference
            }
        }        
        else{
            body = {
                customer: customer,
                material: material,
                quantity: quantity,
                plant: plant,
                availabilityDate: availabilityDate
            }
        }
        let response = null;
        try {
            switch (pathname) {
                case "/dashboard/products/CatGeneric":
                    response = await saveGenericModelList(token, body)
                    break;
                case "/dashboard/products/CotscoProd":
                    response = await saveCotscoProdInventory(token, body)
                    break;
                case "/dashboard/products/GenericProd":
                    response = await saveGenericProdInventory(token, body)
                    break;
                default:
                    response = await saveProductModelList(token, body)
            }		
            
            if (response.status === 201) {
                notifyProductSaved("Product has been successfully saved")
                setSavingIsLoading(false)                
                clearForm()
            }
        } catch(err) {
            if (err.response.status === 400) {
                if (err.response.data.message === "The entry has duplicate values") {
                    notifyDuplicatesModelList(err.response.data.message)
                } else if (err.response.data.content.length > 0) {
                    showDataEntityErrors(err.response.data.content)
                }
            }
        } finally {
            setSavingIsLoading(false)
        }
    }

    const editProductModelListAction = async ()=>{
        if(customer === "" || plant === "" || material === "") {
            notifyInvalidEntity("Customer, Plant and Material are required")
            return
        }
        if (pathname === "/dashboard/products/CotscoProd" || pathname === "/dashboard/products/GenericProd") {
            const isValid = validarExpresionRegular();
            if (!isValid) {
                setSavingIsLoading(false);
                return;
            }
        }
        setSavingIsLoading(true)
        let body = {}
        if (showExtraFields) {
            body = {
                customer: customer,
                material: material,
                quantity: quantity,
                plant: plant,
                storageLocation: storageLocation,
                crossReference: crossReference
            }
        }
        else {
            body = {
                customer: customer,
                material: material,
                quantity: quantity,
                plant: plant,
                availabilityDate: availabilityDate
            }
        }
        let response = null;
        try {
            switch (pathname) {
                case "/dashboard/products/CatGeneric":
                    response = await editGenericModelList(token, body, productOject.id)
                    break;
                case "/dashboard/products/CotscoProd":
                    response = await editCotscoProdInventory(token, body, productOject.id)
                    break;
                case "/dashboard/products/GenericProd":
                    response = await editGenericProdInventory(token, body, productOject.id)
                    break;
                default:
                    response = await editProductModelList(token, body, productOject.id)
            }	             
            if (response.status === 200) {
                notifyProductSaved("Product has been successfully edited")
                setSavingIsLoading(false)                
                clearForm()
                fetchData()
                handleCloseModal()
            }
        } catch(err) {
            if (err.response.status === 400) {
                showDataEntityErrors(err.response.data.content)
            }
        } finally {
            setSavingIsLoading(false)
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        switch(action) {
            case "ADD":
                saveProductModelListAction()
                break;
            case "EDIT":
                editProductModelListAction()
                break;
            default:
                break;
        }
    }

    const loadFields = () => {
        if (pathname === "/dashboard/products/CotscoProd" || pathname === "/dashboard/products/GenericProd") {            
            setShowExtraFields(false);
        } else {            
            setShowExtraFields(true);
        }

    }

    useEffect(() => {
        loadFields();
    }, [pathname])

    return (
        <Container maxWidth="sm" sx={AddOrEditFormStyles.form}>
            <form className={AddOrEditFormStyles.form} onSubmit={(e) => handleSubmit(e)}>
                <Grid container>
                    <Grid item xs={6}>
                        <TextField 
                            fullWidth id="outlined-basic" label="Customer" variant="outlined" sx={AddOrEditFormStyles.textFieldStyle}
                            value={customer} onChange={(e) => setCustomer(e.target.value)} required={true}
                        />
                        <TextField fullWidth id="outlined-basic" label="Material" variant="outlined" sx={AddOrEditFormStyles.textFieldStyle}
                            value={material} onChange={(e) => setMaterial(e.target.value)} required={true}
                        />
                        <TextField
                            id="outlined-number"
                            label="Quantity"
                            type="number"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            fullWidth
                            sx={AddOrEditFormStyles.textFieldStyle}
                            value={quantity} onChange={(e) => setQuantity(parseInt(e.target.value))}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField fullWidth id="outlined-basic" label="Plant" variant="outlined" sx={AddOrEditFormStyles.textFieldStyle} 
                            value={plant} onChange={(e) => setPlant(e.target.value)} required={true}
                        />
                        {showExtraFields && (
                        <>
                            <TextField
                                id="outlined-number"
                                label="Storage Location"
                                type="number"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                                sx={AddOrEditFormStyles.textFieldStyle}
                                value={storageLocation} onChange={(e) => setStorageLocation(parseInt(e.target.value))}
                            />
                            <TextField fullWidth id="outlined-basic" label="Cross Reference" variant="outlined" sx={AddOrEditFormStyles.textFieldStyle} 
                                value={crossReference} onChange={(e) => setCrossReference(e.target.value)}
                            />
                        </>
                        )}
                        {!showExtraFields && (
                            <>                                
                                <TextField fullWidth id="outlined-basic" label="Availability Date" variant="outlined" sx={AddOrEditFormStyles.textFieldStyle}
                                    placeholder="2025.12.31" inputProps={{ maxLength: 10 }} value={availabilityDate} 
                                    onChange={(e) => setAvailabilityDate(e.target.value)}
                                />
                            </>
                        )}
                    </Grid>
                </Grid>
                <Grid container sx={AddOrEditFormStyles.formActions} >
                    <Button onClick={handleCloseModal} variant="contained" sx={GeneralStyles.btnGrey}>Cancel</Button>
                    <Button type="submit" variant="contained" style={{marginLeft: 10}}>
                        {savingIsLoading ? <CircularProgress size={24} /> : "SAVE"}
                    </Button>
                </Grid>
            </form>       
        </Container>
    )
}

export default AddOrEditProductForm